import React from "react";

import { SearchInputProps } from "@models/components/organisation.model";

const SearchInput: React.FC<SearchInputProps> = ({
  label,
  setValue,
  value,
}) => {
  return (
    <div className="form-floating mb-3" data-testid="search-input">
      <input
        type="text"
        className="form-control"
        id="fg-booking-search-field-input"
        placeholder={label}
        value={value}
        onChange={e => setValue(e.target.value)}
      />
      <label htmlFor="fg-booking-search-field-input">{label}</label>
    </div>
  );
};

export default SearchInput;
